// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { removeCookie } from "@insite/client-framework/Common/Cookies";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteSignIn } from "@insite/client-framework/Store/Context/Handlers/SignIn";

export const RemoveCheckoutRecaptchaCookiesAfterSignIn: typeof DispatchCompleteSignIn = () => {
    if (typeof window === "undefined") {
        return;
    }
    removeCookie("g-recaptcha-verified");
    removeCookie("g-recaptcha-response");
};

addToChainAfter(chain, DispatchCompleteSignIn, RemoveCheckoutRecaptchaCookiesAfterSignIn);
